/* Source: src/mt-includes/js/src/moto_validation/init.js*/
angular.module('moto.validation', []);
